export default "__VITE_ASSET__QbhQQYgY__"